import { render, staticRenderFns } from "./ProductionReport.vue?vue&type=template&id=530c4cd1&scoped=true"
import script from "./ProductionReport.vue?vue&type=script&lang=js"
export * from "./ProductionReport.vue?vue&type=script&lang=js"
import style0 from "./ProductionReport.vue?vue&type=style&index=0&id=530c4cd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530c4cd1",
  null
  
)

export default component.exports